(function ($) {
    'use strict';

    let shop_page_url = settings.shop_page_url;
    let default_number_of_columns = settings.customizer_product_columns;
    let windowWidth = screen.width;

    $(document).ready(function () {
        let catalog_containers = [
            'filter__browse',
            'filter-widget-container-js',
            'prodigy-pagination',
            'catalog-sort-js',
            'price-filter-container-js'
        ];

        init();

        function init() {
            set_search_parameters();
            set_dropdown_sortable();
            search_handler();
            slow_search();
            hiding_search_widget();
            hiding_empty_search_space();
            set_number_of_columns_by_screen_resolution();
            if (!window.is_elementor_template()) {
                customize_sort_dropdown();
            }
        }

        function customize_sort_dropdown() {
            if ($.fn.styler) {
                jQuery('.prodigy-custom-select').styler({
                    onFormStyled: function () {
                        jQuery('.jq-selectbox__select-text').each(function () {
                            const width = jQuery(this)
                                .closest('.jq-selectbox')
                                .find('select')
                                .width();
                        });
                    }
                });
            }
        }

        function set_number_of_columns_by_screen_resolution() {
            $('.prodigy-product-list__grid').removeClass('d-none');
            let number_of_columns = '';

            if (windowWidth >= 1440) {
                number_of_columns = default_number_of_columns;
            } else if (windowWidth >= 1024) {
                number_of_columns = (default_number_of_columns >= 4) ? 4 : default_number_of_columns;
            } else if (windowWidth >= 768) {
                number_of_columns = (default_number_of_columns >= 3) ? 3 : default_number_of_columns;
            } else if (windowWidth >= 375) {
                number_of_columns = (default_number_of_columns >= 2) ? 2 : default_number_of_columns;
            }

            $('.shop-resolution-js').addClass('prodigy-product-list__grid-' + number_of_columns);
        }

        function hiding_empty_search_space() {
            let search = $('.catalog-page-sort-js');
            let sorting = $('.prodigy-search__input-js');
            if (search.length === 0 && sorting.length === 0) {
                $('.prodigy-search-filter').remove();
            }
        }

        function hiding_search_widget() {
            $('.prodigy-filter__main').each(function (index, element) {
                let badge = $(element).find('.prodigy-filter__badges');
                let container_attribute = badge.find('.prodigy-main-badge');
                let active_filter = container_attribute.data('attribute-name');
                if (badge.length !== 0 && typeof active_filter === 'undefined') {
                    element.remove();
                }
            });
        }

        function slow_search() {
            if (prodigyGetUrlParam('search')) {
                $("html,body").animate({scrollTop: 0}, "slow");
            }
        }

        function search_handler() {
            const searchBtn = $('.prodigy-search__icon-js');
            const searchWidgetBtn = $('.prodigy-search__icon-widget-js');
            const closeSearchBtn = $('.prodigy-search__close-icon');
            const searchInput = $('.prodigy-search__input-js');
            const searchCustom = $('.prodigy-search__custom-search');
            const backdropOverlay = $('body');
            const searchForm = $('#prodigy-search-form');

            searchWidgetBtn.on('click', (e) => {
                e.preventDefault();
                let input = $(e.target).closest('form').find('.prodigy-search__input-js, .prodigy-search__input-mobile-js');
                if (!input.length) {
                    return;
                }
                set_search_params(input.val());
            });

            searchBtn.on('click', () => {
                e.preventDefault();
                localStorage.removeItem('price-range');
                localStorage.removeItem('catalog-sortable');

                /**
                 * for prodigy theme
                 */
                searchInput.toggleClass('prodigy-search__input-is-open');
                searchInput.focus();

                if (searchInput.hasClass('prodigy-search__input-is-open') && searchInput.val().length > 0) {
                    setTimeout(function () {
                        closeSearchBtn.removeClass('d-none');
                    }, 200);
                } else {
                    closeSearchBtn.addClass('d-none');
                }

            });

            if (typeof searchInput.val() !== 'undefined' && searchInput.val().length > 0) {
                searchInput.addClass('prodigy-search__input-is-open');
                closeSearchBtn.removeClass('d-none');
            }

            searchInput.on('keyup', function () {
                if (searchInput.val().length > 0) {
                    closeSearchBtn.removeClass('d-none');
                } else {
                    closeSearchBtn.addClass('d-none');
                }
            });

            closeSearchBtn.on('click', function () {
                searchInput.val('');
                $(this).addClass('d-none');
                window.history.replaceState({}, document.title, shop_page_url);
                document.location.reload();
            });

            searchCustom.on('click', function (e) {
                e.stopPropagation();
                const dropdown = $(this).closest(".prodigy-search__custom-dropdown");
                dropdown.addClass("prodigy-search__custom-dropdown--open");
                dropdown.attr('aria-expanded', 'true');
                searchForm.attr('aria-hidden', 'false');
                searchInput.focus();
            });

            backdropOverlay.on('click', function (e) {
                if (!$(e.target).closest('.prodigy-search__custom-dropdown-block-search').length) {
                    $('.prodigy-search__custom-dropdown').removeClass("prodigy-search__custom-dropdown--open").attr('aria-expanded', 'false');
                    searchForm.attr('aria-hidden', 'true')
                }
            });

        }

        function set_search_parameters() {
            var search = prodigyGetUrlParam('search');
            if (typeof search !== 'undefined' && search !== 0) {
                $('.prodigy-search__input-js').val(prodigyGetUrlParam('search'));
            }

            $(document).on('keypress', '.prodigy-search__input-js, .prodigy-search__input-mobile-js', function (e) {
                let target = $(e.currentTarget);
                if (e.which === 13 && target.val() && typeof target.val() !== 'undefined') {
                    e.preventDefault();
                    set_search_params(target.val());
                }
            });
        }

        function set_search_params(search_value) {
            let newParams = [
                ['search', search_value],
            ];

            window.history.replaceState({}, document.title, shop_page_url);
            let newUrl = document.location.pathname + prodigyInsertUrlParams(newParams);

            history.pushState('', '', newUrl);
            document.location.reload();
        }

        function set_dropdown_sortable() {
            var selText = '';
            var sort_param = prodigyGetUrlParam('sort');
            var dropdown_container = $(".prodigy-dropdown__menu a");

            switch (sort_param) {
                case 'created_at':
                    selText = 'Sort by newness';
                    break;
                case 'rating':
                    selText = 'Sort by average rating';
                    break;
                case 'price':
                    selText = 'Sort by price';
                    break;
                default:
                    selText = 'Sort by newness';
                    break;
            }

            dropdown_container.parents('.btn-group').find('.prodigy-dropdown__btn').html(selText + ' <span class="caret"></span>');

            dropdown_container.click(function (e) {
                selText = $(this).text();
                $(this).parents('.btn-group').find('.prodigy-dropdown__btn').html(selText + ' <span class="caret"></span>');
            });
        }

        const filterToggleBtnHandler = () => {
            $('.prodigy-shop-sidebar').toggleClass('prodigy-shop-sidebar--open');
            $('body').toggleClass('prodigy-overflow-y-hidden');
            $('html').toggleClass('prodigy-overflow-y-hidden');
        }

        $('body').on('click', '#filter-toggle-btn-close, #filter-toggle-btn-elementor-js, .prodigy-filter-toggle-btn-2, #shop-sidebar-backdrop-js, #shop-sidebar-backdrop-elementor-js', filterToggleBtnHandler);
    });
})(jQuery);
